// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oeos-loader-center[data-v-478cbb50]{text-align:center;-o-object-fit:contain;object-fit:contain;width:300px;display:block;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
